/**
 * SWELL標準スライダーのレスポンシブ表示崩れ（検証ツール等でのリサイズバグ）を強制リセットする関数
 */
export default function initSwellSwiperReset() {
	window.addEventListener("resize", () => {
		// SWELLの標準スライダー要素（.swiper-container または .swiper）をすべて取得
		const swellSwipers = document.querySelectorAll(".swiper-container, .swiper");

		swellSwipers.forEach((el) => {
			// 要素に紐付いているSwiperのインスタンスが存在する場合のみ実行
			if (el.swiper) {
				// 画面幅の変化に合わせて、内部サイズとレイアウトを強制アップデート
				el.swiper.update();
			}
		});
	});
}
